<template>
  <article class="uploader">
    <label v-html="label"></label>
    <b-form-file
      v-model="file"
      :name="name"
      :readonly="readonly"
      @input="handleInput"
    />
    <b-progress
      :value="progress"
      animated
      variant="secondary"
      height="1rem"
      v-if="progress"
    />
  </article>
</template>

<script>
import Evaporate from "evaporate";
import AWS from "aws-sdk";
import uniqid from "uniqid";

let xAmzHeadersCommon = { "x-amz-security-token": _CONFIG.S3_TOKEN };
let xAmzHeadersAtInitiate = xAmzHeadersCommon;

export default {
  props: {
    name: {},
    label: {},
    value: {},
    readonly: {
      default: false,
    },
  },
  data() {
    return {
      progress: 0,
      file: null,
      signingURL: "/uploads/sign",
    };
  },
  computed: {
    id() {
      return "uploader-" + this.name;
    },
  },
  methods: {
    handleInput() {
      if (this.file) {
        this.upload();
      }
    },
    async upload() {
      try {
        let evaporate = await Evaporate.create({
          bucket: _CONFIG.S3_BUCKET,
          awsRegion: _CONFIG.S3_REGION,
          aws_key: _CONFIG.AWS_KEY,
          signerUrl: "/uploads/sign",
          computeContentMd5: false,
          awsSignatureVersion: "2",
          logging: false,
        });
        let path = await evaporate.add({
          name: "uploads/" + uniqid() + "/" + this.file.name,
          file: this.file,
          progress: (p) => (this.progress = Math.floor(p * 100)),
          xAmzHeadersCommon,
          xAmzHeadersAtInitiate,
        });
        this.uploadSuccess(path);
      } catch (error) {
        this.uploadError(error);
      }
    },
    uploadError(errorMessage) {
      alert(errorMessage);
      this.$emit("error", errorMessage);
    },
    async uploadSuccess(path) {
      this.progress = 0;
      this.$emit("input", path);
    },
  },
};
</script>
